<template>
  <div class="page-wrapper">
    <div v-if="$route.name === activeName + 'RobotList'">
      <el-tabs v-model="robotType">
        <el-tab-pane :label="$t('channel.conventional')" name="normal">
          <div class="search-wrapper">
            <el-input size="small" v-model="normal.searchParams.search" :placeholder="$t('robot.enter')">
              <el-button slot="append" icon="iconfont icon-sousuo" @click="handleSearch('normal')"></el-button>
            </el-input>
            <el-button
              type="primary"
              icon="iconfont icon-xiazai"
              v-log="{ page_event: 'c_download' }"
              @click="handleDownload('normal')"
              :loading="normal.downloadLoading"
              size="small"
              class="download"
            >
              {{ $t('calldetails.download') }}
            </el-button>
          </div>
          <RobotTable
            ref="normalTable"
            type="normal"
            :info="normal"
            @audition="handleAudition"
            @remark="handleEditRemark"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></RobotTable>
        </el-tab-pane>
        <el-tab-pane :label="$t('channel.diy')" name="ivr">
          <div class="search-wrapper">
            <el-input size="small" v-model="ivr.searchParams.search" :placeholder="$t('robot.enter')">
              <el-button slot="append" icon="iconfont icon-sousuo" @click="handleSearch('ivr')"></el-button>
            </el-input>
            <el-button type="primary" icon="iconfont icon-xiazai" v-log="{ page_event: 'c_download' }" @click="handleDownload('ivr')" :loading="ivr.downloadLoading" size="small" class="download">
              {{ $t('calldetails.download') }}
            </el-button>
          </div>

          <RobotTable ref="ivrTable" type="ivr" :info="ivr" @audition="handleAudition" @remark="handleEditRemark" @current-change="handleCurrentChange" @size-change="handleSizeChange"></RobotTable>
        </el-tab-pane>
      </el-tabs>

      <!-- 编辑弹框 -->
      <BaseDialog :visible="dialogVisible" @submitPopupData="handleSubmit" popupWidth="520px" @handleClose="handleClose" :dialogTitle="$t('robot.edit_remark')" inline-form :footCenter="true">
        <el-form ref="updateForm" size="small" :rules="rules" :model="updateForm" inline-message @submit.native.prevent>
          <el-form-item :label="$t('robot.remark')" prop="remark">
            <el-input v-model="updateForm.remark" type="text" maxlength="40" show-word-limit></el-input>
          </el-form-item>
        </el-form>
      </BaseDialog>
      <!-- 试听录音 -->
      <BaseDialog :dialogTitle="dialogTitle" :visible="recordDialogVisible" noFooter isViewDialog @handleClose="handleCloseDiaolog" :footCenter="true">
        <audio-player
          :ref="'audio_' + index"
          class="audio-box"
          v-show="item"
          :fileurl="item"
          v-for="(item, index) in recordingList"
          :key="index"
          @playAudio="changeAudio"
          :subscript="index"
        ></audio-player>
      </BaseDialog>
    </div>

    <!-- 查看详情 -->
    <router-view v-else></router-view>
  </div>
</template>
<script>
import fileDownload from 'js-file-download'
import { getRobotList, downLoadRobotList, postUpdateRobotRemark } from '../../api/Robot'
import BaseDialog from '@/components/common/baseDialog.vue'
import AudioPlayer from '../Template/RobotExperience/components/audioPlayer.vue'
import RobotTable from './components/RobotTable.vue'

export default {
  components: {
    BaseDialog,
    AudioPlayer,
    RobotTable
  },
  data() {
    return {
      activeName: sessionStorage.getItem('activeName'),
      robotType: 'normal',
      normal: {
        searchParams: {
          page: 1,
          limit: 10,
          robot_type: 'normal',
          product: this.$store.getters.businessType,
          search: ''
        },
        tableData: [],
        listLoading: false,
        count: 0,
        downloadLoading: false
      },
      ivr: {
        searchParams: {
          page: 1,
          limit: 10,
          robot_type: 'ivr',
          product: this.$store.getters.businessType,
          search: ''
        },
        tableData: [],
        listLoading: false,
        count: 0,
        downloadLoading: false
      },
      dialogTitle: '',
      recordDialogVisible: false,
      recordingList: [],
      dialogVisible: false,
      updateForm: {
        remark: '',
        id: ''
      },
      rules: {
        remark: [{ max: 40, message: this.$t('robot.remark_max_length'), trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.reloadData()
    this.handleSearch('normal')
    this.handleSearch('ivr')
  },
  methods: {
    reloadData() {
      this.handleSearch('normal')
      this.handleSearch('ivr')
    },
    handleAudition(row) {
      this.dialogTitle = row.robot_name
      this.recordingList = row.records
      this.recordDialogVisible = true
    },
    changeAudio(i, type) {
      // type区分点击icon或者拖拽进度条,拖拽：drag
      this.recordingList.forEach((item, index) => {
        if (i !== index) {
          this.$refs['audio_' + index][0].resultAudio(index)
        } else if (type !== 'drag') {
          this.$refs['audio_' + index][0].playAudio()
        }
      })
    },
    handleCloseDiaolog() {
      this.recordingList.forEach((item, index) => {
        this.$refs['audio_' + index][0].fetch(index)
      })
      this.recordDialogVisible = false
      this.recordingList = []
    },
    handleEditRemark(row) {
      this.dialogVisible = true
      Object.assign(this.updateForm, row)
    },
    handleSubmit() {
      this.$refs.updateForm.validate(valid => {
        if (!valid) {
          return false
        }
        postUpdateRobotRemark(this.updateForm).then(res => {
          this.dialogVisible = false
          this.reloadData()
          this.fetch(this.robotType)
        })
      })
    },
    // 关闭dialog
    handleClose() {
      this.$refs['updateForm'].resetFields()
      this.dialogVisible = false
      this.fetch(this.robotType)
    },
    handleDownload(type) {
      this[type].downloadLoading = true
      const { search, product, language, robot_type } = this[type].searchParams
      downLoadRobotList({ search, product, language, robot_type })
        .then(res => {
          let filename = res.headers['content-disposition'].split('attachment; filename=')[1]

          fileDownload(res.data, decodeURIComponent(filename))
        })
        .finally(() => {
          this[type].downloadLoading = false
        })
    },
    handleReset(type) {
      this[type].searchParams.page = 1
      this[type].searchParams.limit = 10
      this[type].searchParams.search = ''
      this.fetch(type)
    },
    handleSearch(type) {
      this[type].searchParams.page = 1
      this.fetch(type)
    },
    handleSizeChange(val, type) {
      this[type].searchParams.page = 1
      this[type].searchParams.limit = val
      this.fetch(type)
    },
    handleCurrentChange(val, type) {
      console.log('type', type)
      this[type].searchParams.page = val
      this.fetch(type)
    },
    fetch(type) {
      this[type].listLoading = true
      this[type].searchParams.language = this.$i18n.locale
      getRobotList(this[type].searchParams)
        .then(res => {
          const {
            data: { robots, count }
          } = res.data
          this[type].tableData = robots
          this[type].count = count
        })
        .finally(() => {
          this[type].listLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.stateTag {
  min-width: 140px;
}
.search-wrapper {
  padding: 12px 32px 0;
  height: 84px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  /deep/ .el-input-group {
    width: 320px;
    display: flex;

    .el-input__inner {
      flex: 1;
    }

    .el-input-group__append {
      width: 40px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 32px;

      .el-button {
        padding: 8px 12px;
        margin: -8px -12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Robot/index.vue